// Pluggable analytics. Faz 2 events added.
import { api } from "./api";

const EVENTS = [
  "program_view", "program_cta_click", "atelier_pre_registration_started",
  "atelier_pre_registration_completed", "institutional_form_started",
  "institutional_form_completed", "newsletter_signup", "content_view", "outbound_click",
  "signup_started", "signup_completed", "login", "product_view", "add_to_cart",
  "remove_from_cart", "begin_checkout", "payment_success", "payment_failure",
  "purchase", "event_view", "booking_started", "booking_completed", "waitlist_joined", "digital_download",
];

export function track(event, props = {}) {
  if (!EVENTS.includes(event)) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...props });
  api.post("/analytics", { event, props }).catch(() => {});
}
